import { render } from "./BatchStatusPill.vue?vue&type=template&id=a271f7e8"
import script from "./BatchStatusPill.vue?vue&type=script&lang=js"
export * from "./BatchStatusPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__